module.exports = __webpack_public_path__ + "static/media/gemscape1.ee66fd8f.svg";